import React, { useRef, useEffect, useState } from 'react'

import useIsFirstRender from '../../is_first_render.js'

import useInteractionZone from './InteractiveZone.jsx'

import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'

import ahoy from "ahoy.js"

const PlayIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<polygon points="8,5 19,12 8,19" fill="currentColor" />
	</svg>
)

const PauseIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="6" y="5" width="4" height="14" fill="currentColor" />
		<rect x="14" y="5" width="4" height="14" fill="currentColor" />
	</svg>
)

// TODO:
// useInteractionZone(interaction_zone_rect)
// and context provider w/ scaled_width scaled_height
const AudioPlayer = ({ song, song_rect, interaction_zone_rect }) => {
	const is_first_render = useIsFirstRender()

	const [player_clicked, setPlayerClicked, interaction_zone] = useInteractionZone(interaction_zone_rect)

	const audio_ref = useRef(null)
	const play_button_ref = useRef(null)

	useEffect(()=>{
		const audio = audio_ref.current

		if(!audio || is_first_render){
			return
		}

		const action = player_clicked ? 'play' : 'pause'

		audio[action]()

		ahoy.track('AudioPlayer', { action: action, song_time: audio.currentTime })
	}, [player_clicked])

	useGSAP(
		() => {
			if(is_first_render){
				return
			}
			const play_button = play_button_ref.current

			gsap.set(play_button, { opacity: 0.8, zIndex: 2 })

			gsap.to(play_button, { scale: 8, opacity: 0 })
		},
		{ dependencies: [player_clicked], revertOnUpdate: true }
	)

	return (
		<span
			className={
				`absolute
				text-white text-center
				text-md
				-translate-x-1/2 -translate-y-1/2
				experience-audio-player
				`
			}
			style={{
				left: song_rect.left + '%',
				top: song_rect.top + '%',
				maxWidth: 20 + '%'
			}}
			//onClick={onSongClick}
		>
			{/* opacity-[0.5] */}
			<span
				ref={play_button_ref}
				className={`
					text-white text-shadow-strong text-center
					text-2xl
					flex justify-center items-center
					leading-none
					w-[50px] h-[50px]
					bg-neutral-950/75
					rounded-full
					font-sans
					opacity-0
					absolute
					top-0 left-0
					-translate-x-1/2 -translate-y-1/2
					pointer-events-none
					z-[2]
				`}
			>
				{(!player_clicked ? <PauseIcon /> : <PlayIcon />)}
			</span>

			{interaction_zone}

			<audio ref={audio_ref} >
				<source src={song} />
			</audio>
		</span>
	)	
}


export default AudioPlayer